export default __webpack_public_path__ + "assets/artsakh-flag.png";